import { LocationData } from "./LocationData";
import { OrganizationData } from "./OrganizationData";

export enum AccountType {
  ADMIN = "admin",
  ORG_ADMIN = "org_admin",
  LOC_ADMIN = "loc_admin"
}

/**
 * Account data model as returned from the API
 */
export interface AccountDataAPI {
  id: number;
  uuid: string;
  name: string;
  type: AccountType;
  role: string;
  refresh_token: string;
  email: string;
  activated: boolean;
  organization?: OrganizationData;
  accounts: string[];
  locations: LocationData[];
  locations_accounts: any[];
  created_at: string;
  created_by: number;
  last_modified_at: string;
  last_modified_by: number;
  organization_id: string | null;
  is_impersonating?: boolean;
  linked_to_google_account: boolean | null;
  last_login_at: string;
}

/**
 * Account data model used by the client, only includes fields necessary for the client
 */
export interface AccountData {
  id: number;
  uuid: string;
  name: string;
  type: AccountType;
  role: string;
  refresh_token: string;
  email: string;
  activated: boolean;
  organization?: OrganizationData;
  accounts: string[];
  locations: LocationData[];
  locations_accounts: any[];
  created_at: string;
  created_by: number;
  last_modified_at: string;
  last_modified_by: number;
  organization_id: string | null;
  is_impersonating?: boolean;
  linked_to_google_account: boolean | null;
}

export interface AccountInformationData {
  familyName: string;
  firstName: string;
  email: string;
  role: string;
}
